import React from 'react';
import PropTypes from 'prop-types';
import useSectionStyles from './sectionstyles';

import SettingCheckbox from './settingcheckbox';

const EncounterProcessingSection = ({
  contractSettingsData,
  boundActions
}) => {
  const {
    autoExport,
    documentProcessorAutofinalize,
    documentProcessorReadAutofinalized,
    purgeContractDuringNextRead,
    isClientReviewEnabled,
    selectedContract: { contractId, isRereadDisabled }
  } = contractSettingsData;

  const classes = useSectionStyles();

  return (
    <div className={classes.encounterProcessing}>
      <h5 style={{ margin: '0' }}><u>Encounter Processing and Doc Proc</u></h5>

      <div>
        <SettingCheckbox
          name="isClientReviewEnabled"
          isChecked={isClientReviewEnabled.isChecked}
          text="Enable Client Review"
          onChange={() => {
            isClientReviewEnabled.isChecked
              ? boundActions.disableClientReview(contractId)
              : boundActions.enableClientReview(contractId)
          }}
        />
      </div>

      {/* Auto Export */}
      <div>
        <SettingCheckbox
          name="autoExport"
          isChecked={autoExport.isChecked}
          text="Automatic Export and Approval"
          onChange={() => {
            autoExport.isChecked
              ? boundActions.disableAutoExport(contractId)
              : boundActions.enableAutoExport(contractId);
          }}
        />
      </div>

      {/* Purge Contract During Next Read */}
      <div>
        <SettingCheckbox
          name="disableAutoReread"
          isChecked={isRereadDisabled}
          text="Stop automatic rereads"
          onChange={() => {
            isRereadDisabled
              ? boundActions.enableAutoReread(contractId)
              : boundActions.disableAutoReread(contractId)
          }}
        />
        {/* <button onClick={() => boundActions.purgeEncounters(contractId)}>Purge Encounters</button> */}
      </div>

      {/* Doc Proc Autofinalize */}
      <div>
        <SettingCheckbox
          name="documentProcessorAutofinalize"
          isChecked={documentProcessorAutofinalize.isChecked}
          text="Doc Proc Autofinalize"
          onChange={() => {
            documentProcessorAutofinalize.isChecked
              ? boundActions.disableDocProcAutofinalize(contractId)
              : boundActions.enableDocProcAutofinalize(contractId)
          }}
        />
      </div>

      {/* Doc Proc Read Previously Autofinalized */}
      <div>
        <SettingCheckbox
          name="documentProcessorReadAutofinalized"
          isChecked={documentProcessorReadAutofinalized.isChecked}
          text="Doc Proc Reads Previously Autofinalized Encounters"
          onChange={() => {
            documentProcessorReadAutofinalized.isChecked
              ? boundActions.disableAutofinalizedEncounterDocProcRead(contractId)
              : boundActions.enableAutofinalizedEncounterDocProcRead(contractId)
          }}
        />
      </div>
    </div>
  );
};

EncounterProcessingSection.propTypes = {};

export default EncounterProcessingSection;
